export enum SUB_ORDER_ERROR {
  INVALID_ORDER_STATUS = 'INVALID_ORDER_STATUS',
  IMPORT_STATUS_FILE_ERROR = 'SE001',
  STATUS_NOT_ALLOWED = 'STATUS_NOT_ALLOWED',
  STATUS_NOT_SAME = 'STATUS_NOT_SAME',
}

export const SUB_ORDER_ERRORS = {
  [SUB_ORDER_ERROR.INVALID_ORDER_STATUS]: {
    description: 'subOrder:errors.INVALID_ORDER_STATUS',
  },
  [SUB_ORDER_ERROR.IMPORT_STATUS_FILE_ERROR]: {
    description: 'subOrder:errors.IMPORT_STATUS_FILE_ERROR',
  },
  [SUB_ORDER_ERROR.STATUS_NOT_ALLOWED]: {
    description: 'subOrder:errors.STATUS_NOT_ALLOWED',
  },
  [SUB_ORDER_ERROR.STATUS_NOT_SAME]: {
    description: 'subOrder:errors.STATUS_NOT_SAME',
  },
};
